var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var PreviousRouteService = /** @class */ (function () {
    function PreviousRouteService(router) {
        this.router = router;
        this.history = [];
    }
    PreviousRouteService.prototype.loadRouting = function () {
        var _this = this;
        this.router.events
            .pipe(filter(function (event) { return event instanceof NavigationEnd; }))
            .subscribe(function (_a) {
            var urlAfterRedirects = _a.urlAfterRedirects;
            _this.history = __spread(_this.history, [urlAfterRedirects]);
        });
    };
    PreviousRouteService.prototype.getHistory = function () {
        return this.history;
    };
    PreviousRouteService.prototype.getPreviousUrl = function () {
        return this.history[this.history.length - 2] || '/';
    };
    PreviousRouteService.ngInjectableDef = i0.defineInjectable({ factory: function PreviousRouteService_Factory() { return new PreviousRouteService(i0.inject(i1.Router)); }, token: PreviousRouteService, providedIn: "root" });
    return PreviousRouteService;
}());
export { PreviousRouteService };
